<template>
  <div class="home">
    
    <v-container>
      <v-layout align-center column justify-center my-5 py-5>
        <h1 class="display-3 black--text font-weight-thin mb-3">Turing Form</h1>
        <h4 class="subheading black--text text-xs-center">Simple and free forms for your tribe</h4>

        <router-link to="/create">
          <v-btn class="mt-5 action-button" color="primary" dark large>Create a form</v-btn>
        </router-link>

        <router-link to="/login">
          <v-btn v-if="!userObj" class="mt-3 action-button" large>Login</v-btn>
        </router-link>

        <router-link to="/myforms">
          <v-btn v-if="userObj" color="info" class="mt-3 action-button" large>
            Manage My Forms
          </v-btn>
        </router-link>
      </v-layout>
    </v-container>

    

    <div class="grey darken-3">
      <v-container>
          <v-layout row wrap>
            
            <v-flex xs12 md6 lg4>
              <v-card color="grey darken-3" class="white--text" flat :raised="false">
                <v-card-title primary-title>
                  <h1>unlimited 🥤</h1>
                </v-card-title>
                <v-card-text>
                  <h3>unlimited forms, questions and responses</h3>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 lg4>
              <v-card color="grey darken-3" class="white--text" flat :raised="false">
                <v-card-title primary-title>
                  <h1>fastest experience ⏩</h1>
                </v-card-title>
                <v-card-text>
                  <h3>⚡fast form creation and responses</h3>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 lg4>
              <v-card color="grey darken-3" class="white--text" flat :raised="false">
                <v-card-title primary-title>
                  <h1>results for humans 🤗</h1>
                </v-card-title>
                <v-card-text>
                  <h3>easy and intuitive results</h3>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 lg4>
              <v-card color="grey darken-3" class="white--text" flat :raised="false">
                <v-card-title primary-title>
                  <h1>data export 📖</h1>
                </v-card-title>
                <v-card-text>
                  <h3>your data is private, and accessible</h3>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 lg4>
                <v-card color="grey darken-3" class="white--text" flat :raised="false">
                <v-card-title primary-title>
                  <h1>built for mobile 📱</h1>
                </v-card-title>
                <v-card-text>
                  <h3>looks great on mobile and web</h3>
                </v-card-text>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 lg4>
              <v-card color="grey darken-3" class="white--text" flat :raised="false">
                <v-card-title primary-title>
                  <h1>all free 🆓</h1>
                </v-card-title>
                <v-card-text>
                  <h3>for free. no gimmicks</h3>
                </v-card-text>
              </v-card>
            </v-flex>

          </v-layout>

      </v-container>    
    </div>

    <div>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md6 offset-md3>
            <v-card color="cyan lighten-1" class="white--text mt-5 pa-4">
              <v-card-title primary-title>
                <h1>need more?</h1>
              </v-card-title>
              <v-card-text>
                <h2>Upgrade to Pro for just <strong><u>$5/month</u></strong> and get access to features like:</h2>

                <router-link to="/view/q_6b51a0805f1e11e9b92b1d25ded49c24">
                  <v-btn color="white" class="mt-5" block large>Learn More</v-btn>
                </router-link>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    
    <v-container>
      <v-layout row wrap>
        <v-flex md6 offset-md3 xs12>
          <v-card flat :raised="false">
            <v-card-text class="text-xs-center">
              <h1 class="font-weight-thin mt-3">Sound good?</h1>
              <h2 class="font-weight-thin">Click below to start. No signup required.</h2>

              <router-link to="/create">
                <v-btn class="mt-3 mb-5" color="primary" dark large block>Create a form</v-btn>
              </router-link>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    
  </div>
</template>

<script>
// @ is an alias to /src
import ParallaxImg from '@/assets/parallax.jpeg'


export default {
  name: "home",
  components: {
    ParallaxImg
  },
  data: () => ({
    parallaxImg : ParallaxImg.toString(),
    userObj: null
  }),
  created() {
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user)=> {
      if (user) {
        // User is signed in.
        this.userObj = user;
      } else {
        this.userObj = null;
      }
    });
  }
};
</script>

<style scoped>
  .action-button {
    width: 200px;
  }

  .v-card {
    border-radius: 0 !important;
  }
</style>
